<template>
    <header class="header">
        <nav class="navbar fixed-top">

            <div class="navbar-holder d-flex align-items-center align-middle justify-content-between">

                <div class="navbar-header">

                    <a id="toggle-btn" href="#" class="menu-btn" v-bind:class="menuActive ? 'active': ''" v-on:click="toggleMenu">
                        <span></span>
                        <span></span>
                        <span></span>
                    </a>

                    <router-link to="/" class="navbar-brand">
                        <div class="brand-image brand-big">
                            <img v-bind:src="'/img/' + workspace.workspace_logo" v-bind:alt="workspace.workspace_name" class="img-fluid" style="height: 75px; padding: 6px;">
                        </div>
                        <div class="brand-image brand-small">
                            <img v-bind:src="'/img/' + workspace.workspace_logo" v-bind:alt="workspace.workspace_name" class="img-fluid" style="height: 75px; padding:6px;">
                        </div>
                    </router-link>
                </div>
            </div>

        </nav>
    </header>
</template>

<script>
    export default {
        props: ['workspace'],
        data: function () {
            return {
                menuActive: true
            }
        },
        methods: {
            toggleMenu() {
                this.menuActive = !this.menuActive;
            }
        }
    }
</script>